import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";
import { BookButton } from "@/components/common/BookButton";

export default function NotFound() {
  return (
    <section className="container-tight flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-charcoal text-gold">
        <Landmark size={30} strokeWidth={1.5} />
      </span>
      <p className="mt-8 text-sm font-semibold uppercase tracking-[0.22em] text-gold-dark">
        Lost in the ruins
      </p>
      <h1 className="mt-3 font-serif text-5xl font-medium text-charcoal md:text-6xl">404</h1>
      <p className="mt-4 max-w-md text-lg font-light text-slatey">
        We couldn't find that page. Let's get you back to planning your Colosseum visit.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="rounded-full border border-charcoal px-7 py-3 text-sm font-medium text-charcoal transition-colors hover:bg-charcoal hover:text-white"
        >
          Back to home
        </Link>
        <BookButton label="Browse tickets" testId="notfound-book" />
      </div>
    </section>
  );
}
